import React, { useEffect, useState, useCallback, Fragment } from "react";
//import { useNavigate } from "react-router-dom";
import { Container, Form, Row, Col, InputGroup, Button } from "react-bootstrap";
import { loadMe, updatePassword } from "../../lib/api/auth";
import { MeFormStudent } from "../../components/auth/MeForm";

// ---------------------------------------------------------------
//
//  Header Component
//
// ---------------------------------------------------------------
const HeaderComponent = ({ me }) => {
  if (!me) {
    return null;
  }

  return (
    <Fragment>
      <InputGroup>
        <InputGroup.Text className="w-25">사용자 이름</InputGroup.Text>
        <Form.Control type="text" value={me.displayName} disabled />
      </InputGroup>
      <InputGroup>
        <InputGroup.Text className="w-25">사용자 아이디</InputGroup.Text>
        <Form.Control type="text" value={me.username} disabled />
      </InputGroup>
    </Fragment>
  );
};

// ---------------------------------------------------------------
//
//  Password Component
//
// ---------------------------------------------------------------
const PasswordComponent = ({ handleUpdatePassword }) => {
  const [btnClick, setBtnClick] = useState(false);
  const [password, setPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [newPassword2, setNewPassword2] = useState(null);

  useEffect(() => {
    if (
      password &&
      newPassword &&
      newPassword2 &&
      newPassword === newPassword2
    ) {
      setBtnClick(true);
    } else {
      setBtnClick(false);
    }
  }, [password, newPassword, newPassword2]);

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleNewPassword = (e) => {
    setNewPassword(e.target.value);
  };

  const handleNewPassword2 = (e) => {
    setNewPassword2(e.target.value);
  };

  const handleClickPassword = () => {
    handleUpdatePassword(password, newPassword, newPassword2);
  };

  return (
    <Fragment>
      <hr />
      <Row className="mt-2">
        <Form.Label>비밀 번호</Form.Label>
        <Row className="m-2">
          <Form.Group controlId="password">
            <Form.Label>현재 비밀번호</Form.Label>
            <Form.Control
              onChange={handlePassword}
              type="password"
              placeholder="password"
              required
            />
            <Form.Control.Feedback type="invalid" className={"float-left"}>
              비밀번호를 입력해주세요!
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="new-password">
            <Form.Label>새로운 비밀번호</Form.Label>
            <Form.Control
              onChange={handleNewPassword}
              type="password"
              placeholder="new password"
              // required
            />
            <Form.Control.Feedback type="invalid" className={"float-left"}>
              비밀번호를 입력해주세요!
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="confirm-new-password">
            <Form.Label>새로운 비밀번호 확인</Form.Label>
            <Form.Control
              onChange={handleNewPassword2}
              type="password"
              placeholder="confirm new password"
              // required
            />
            <Form.Control.Feedback type="invalid" className={"float-left"}>
              비밀번호를 입력해주세요!
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Col>
          <Button onClick={handleClickPassword} disabled={!btnClick}>
            변경
          </Button>
        </Col>
      </Row>
      <hr />
    </Fragment>
  );
};

// --------------------------------------------------------------------
//
//  Home Component
//
// --------------------------------------------------------------------
const Home = () => {
  //const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [student, setStudent] = useState(null);

  const requestLoadMe = useCallback(async () => {
    const rsp = await loadMe();
    //console.log(rsp);
    setMe(rsp.data);
    setStudent(rsp.data.student);
  }, []);

  const requestUpdatePassword = useCallback(
    async (password, newPassword, newPassword2) => {
      const rsp = await updatePassword({ password, newPassword, newPassword2 });
      //console.log(rsp);

      if (rsp.status === 401) {
        alert("현재 패스워드를 확인해주세요.");
      } else if (rsp.status === 400) {
        alert("새 패스워드를 확인해주세요.");
      } else if (rsp.status === 200) {
        alert("패스워드 변경을 성공하였습니다.");
      } else {
        alert("패스워드 변경에 오류가 있습니다.");
      }
    },
    []
  );

  useEffect(() => {
    requestLoadMe();
  }, [requestLoadMe]);

  const handleUpdatePassword = (password, newPassword, newPassword2) => {
    requestUpdatePassword(password, newPassword, newPassword2);
  };

  return (
    <Fragment>
      <Container fluid="md">
        <br />
        <HeaderComponent me={me} />
        <PasswordComponent handleUpdatePassword={handleUpdatePassword} />
        {/* <MeFormStudent student={student} /> */}
      </Container>
    </Fragment>
  );
};

export default Home;
